export default __webpack_public_path__ + "static/media/bscscan.961a152d.svg";